import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isFunction } from "lodash";

import { deleteMeterUploadDraft } from "@services/bulkMeterUpload";

export const useDeleteMeterUploadDraft = ({
  onSuccess,
  ...options
}: Record<string, any> = {}) => {
  const queryClient = useQueryClient();
  return useMutation((id: string) => deleteMeterUploadDraft(id), {
    ...options,
    onSuccess: (res: void, id: string) => {
      // We don't know the level1ResourceId from the response; invalidate broadly.
      queryClient.invalidateQueries({ queryKey: ["meterUploads"] });
      queryClient.invalidateQueries({ queryKey: ["meterUpload", id] });
      if (isFunction(onSuccess)) onSuccess(res, id);
    },
  });
};
